import router from '@/router'
import store from '@/store'
import { KeyDict } from '@/types'

const navigate = (
  routeName: string,
  query?: KeyDict<string|(string|null)[]|null|undefined>) => {
  const route = router.resolve({ name: routeName, query: query || {} })
  window.location.href = route.href
}

const exitEvent = () => {
  navigate('events')
}

const endSession = () => {
  const cast = store.state.events.currentCast
  const isAnonymous = !!store.state.user.profile?.anonymous
  if (isAnonymous) navigate('end-session', { name: cast?.name ?? '' })
  else navigate('events')
}

const useLeaveCast = () => {
  return {
    endSession,
    exitEvent
  }
}

export default useLeaveCast
